import React from 'react';
import swal from "sweetalert";
//import { useNavigate } from "react-router-dom";


import {
    formatApiError,
    formatLoginError,
    login,
    registerAgent,
    runLogoutTimer,
    saveTokenInLocalStorage,
    updateProfile,
    updateStoredUserDetails,
    uploadCompanyLogo,
} from '../../services/AuthService';


export const SIGNUP_CONFIRMED_ACTION = '[signup action] confirmed signup';
export const SIGNUP_FAILED_ACTION = '[signup action] failed signup';
export const LOGIN_CONFIRMED_ACTION = '[login action] confirmed login';
export const LOGIN_FAILED_ACTION = '[login action] failed login';
export const LOADING_TOGGLE_ACTION = '[Loading action] toggle loading';
export const LOGOUT_ACTION = '[Logout action] logout action';
export const UPDATE_PROFILE_ACTION = '[update profile action] update profile';



export function agentRegistrationAction(payload, onSuccess, onError) {
    return (dispatch) => {
        registerAgent(payload)
        .then(() => {
            // Registration only submits an application for admin review — it does not
            // create a logged-in session, so we deliberately don't touch state.auth here.
            dispatch(loadingToggleAction(false));
            swal(
                'Thanks for registering!',
                'We will review your details within 24 hours and activate your account.',
                'success',
            );
            if (onSuccess) onSuccess();
        })
        .catch((error) => {
            dispatch(loadingToggleAction(false));
            const apiErrorMessage = error.response && error.response.data && error.response.data.error;
            if (apiErrorMessage && apiErrorMessage.includes('Email Not Send')) {
                // The agent record was still saved on the backend — only the confirmation
                // email failed to send — so this isn't a registration failure. Let the user
                // know their details went through instead of asking them to resubmit.
                swal(
                    'Registered, but email failed to send',
                    'Your details were saved and will be reviewed within 24 hours, but we could not send you a confirmation email.',
                    'warning',
                );
                if (onSuccess) onSuccess();
                return;
            }
            if (error.response) {
                formatApiError(error.response.data, 'Unable to register. Please try again.');
            } else {
                swal('Oops', 'Unable to reach the server. Please try again.', 'error');
            }
            if (onError) onError();
        });
    };
}

export function Logout(navigate) {
	localStorage.removeItem('userDetails');
    navigate('/login');
	//history.push('/login');
    
	return {
        type: LOGOUT_ACTION,
    };
}

export function loginAction(email, password, navigate) {
    return (dispatch) => {
         login(email, password)
            .then((response) => { 
                saveTokenInLocalStorage(response.data);
                runLogoutTimer(
                    dispatch,
                    response.data.expiresIn * 1000,
                    navigate,
                );
               dispatch(loginConfirmedAction(response.data));
				navigate('/dashboard');
            })
            .catch((error) => {
                if (error.response) {
                    formatLoginError(error.response.data);
                    dispatch(loginFailedAction(''));
                } else {
                    const errorMessage = 'Unable to reach the server. Please try again.';
                    swal('Oops', errorMessage, 'error');
                    dispatch(loginFailedAction(''));
                }
            });
    };
}

export function updateProfileAction(patch) {
    return {
        type: UPDATE_PROFILE_ACTION,
        payload: patch,
    };
}

export function saveProfileAction(payload, onSuccess, onError) {
    return (dispatch) => {
        updateProfile(payload)
            .then(() => {
                // password is write-only: never persist it into client-side state/storage
                const { password, ...clientSafePayload } = payload;
                updateStoredUserDetails(clientSafePayload);
                dispatch(updateProfileAction(clientSafePayload));
                swal('Success', 'Profile updated successfully', 'success');
                if (onSuccess) onSuccess();
            })
            .catch((error) => {
                if (error.response) {
                    formatApiError(error.response.data, 'Unable to update profile. Please try again.');
                } else {
                    swal('Oops', 'Unable to reach the server. Please try again.', 'error');
                }
                if (onError) onError();
            });
    };
}

export function uploadLogoAction(agentId, base64Image, onSuccess, onError) {
    return (dispatch) => {
        uploadCompanyLogo(agentId, base64Image)
            .then(() => {
                const patch = { company_logo: base64Image };
                updateStoredUserDetails(patch);
                dispatch(updateProfileAction(patch));
                swal('Success', 'Profile photo updated successfully', 'success');
                if (onSuccess) onSuccess();
            })
            .catch((error) => {
                if (error.response) {
                    formatApiError(error.response.data, 'Unable to upload photo. Please try again.');
                } else {
                    swal('Oops', 'Unable to reach the server. Please try again.', 'error');
                }
                if (onError) onError();
            });
    };
}

export function loginFailedAction(data) {
    return {
        type: LOGIN_FAILED_ACTION,
        payload: data,
    };
}

export function loginConfirmedAction(data) {
    return {
        type: LOGIN_CONFIRMED_ACTION,
        payload: data,
    };
}

export function confirmedSignupAction(payload) {
    return {
        type: SIGNUP_CONFIRMED_ACTION,
        payload,
    };
}

export function signupFailedAction(message) {
    return {
        type: SIGNUP_FAILED_ACTION,
        payload: message,
    };
}

export function loadingToggleAction(status) {
    return {
        type: LOADING_TOGGLE_ACTION,
        payload: status,
    };
}
